import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';

@Component({  
  selector: 'app-rul-stat-dialog',
  templateUrl: './rul-stat-dialog.component.html',
  styleUrls: ['./rul-stat-dialog.component.css']
})
export class RulStatDialogComponent implements OnInit, OnDestroy{
 
  objectKeys = Object.keys;
  viewDetails: any;

  private _statViewConfig: any;
  private _user: string;
  private _userOrAppNameDetailsSubscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _entityService: EntitiesServiceService,
    private _service: ServicecallService
  ) { }

  ngOnInit(): void {
    this.data.item['user'] = 'NA';
    this.viewDetails = JSON.parse(JSON.stringify(this.data?.item));
    this._statViewConfig = this._service.getConfiguration('tenantGenericConfig') ? this._service.getConfiguration('tenantGenericConfig')?.rulStatView : null;
    if (this.data?.item?.metaData?.createdBy) {
      this._userOrAppNameDetailsSubscription = this._entityService.userOrAppNameDetails(this.data?.item?.metaData?.createdBy).subscribe({
        next: (result: any) => {
          this._user = result?.name ? result?.name : 'NA';
          this._setViewData();
        }, error: () => {
          this._user = 'NA';
          this._setViewData();
        }
      });
    } else {
      this._service.toasterService({ type: 'warning', msg: 'Created By field is unavailable' });
    }
  }
  ngOnDestroy(): void {
    this._userOrAppNameDetailsSubscription?.unsubscribe(); 
  }
  private _setViewData() {
    this.objectKeys(this.viewDetails)?.forEach((elem: any) => {
      if (this.objectKeys(this._statViewConfig)?.includes(elem?.toString())) {
        this.viewDetails[this._statViewConfig[elem?.toString()]] = elem?.toString() === 'user' ? this._user : this.viewDetails[elem?.toString()];
      }
      delete this.viewDetails[elem?.toString()];
    });
  }
}
